import Reflux from 'reflux'
import Proxies from 'Components/proxies'
const { GET, POST } = Proxies
import keyMirror from 'keymirror'

export const ProductSyncActions = Reflux.createActions(['getProducts', 'test', 'getSuppliersWithProductSync', 'exportSelection'])

export const STATUS = keyMirror({
  IS_FETCHING: null,
  FETCHING_ERROR: null,
  UPDATE_SUCCESS: null,
  UPDATE_ERROR: null,
  DELETE_ERROR: null,
  DELETE_SUCCESS: null,
  TAKING_INPUT: null,
  IS_SAVING: null,
  REDIRECT: null
})

export class ProductSyncStore extends Reflux.Store {
  constructor(props) {
    super(props)
    this.listenables = ProductSyncActions
    this.state = {
      products: [],
      pageInfo: null,
      totalCount: 0,
      status: null,
      suppliers: []
    }
  }

  getProducts(SupplierID, payload = null) {
    this.setState({ status: STATUS.IS_FETCHING })
    if (SupplierID === '40') {
      this.getNWGProducts(payload)
    } else if (SupplierID === '380') {
      this.getHuurayProducts(payload)
    }
  }

  getNWGProducts(payload) {
    POST('/products/nwg-products', payload).then(responseJSON => {
      let nextState = { products: [] }
      if (responseJSON.error) {
        nextState.status = STATUS.FETCHING_ELEMENTS_ERROR
      } else {
        this.setState({ status: STATUS.UPDATE_SUCCESS })
        nextState.products = responseJSON.result
        nextState.pageInfo = responseJSON.pageInfo
        nextState.totalCount = responseJSON.count
      }
      this.setState(nextState)
    })
  }

  getHuurayProducts(payload) {
    POST('/products/huuray-catalogue', payload).then(responseJSON => {
      let nextState = { products: [] }
      if (responseJSON.error) {
        nextState.status = STATUS.FETCHING_ELEMENTS_ERROR
      } else {
        const productsRaw = responseJSON && Array.isArray(responseJSON.Products) ? responseJSON.Products : []

        const mapped = productsRaw
          .filter(p => p.CountryCode === 'DK')
          .map(p => {
            const denomsArr =
              typeof p.Denominations === 'string'
                ? p.Denominations.split(',')
                    .map(s => s.trim())
                    .filter(Boolean)
                : Array.isArray(p.Denominations)
                ? p.Denominations
                : []

            const pictures = p.LogoFile ? [{ imageUrl: p.LogoFile }] : []
            const skus = denomsArr.map(d => ({
              sku: `${p.ProductToken}-${d}`,
              eanCode: null,
              availabilityRegional: 10000,
              availabilityGlobal: 10000,
              size: d,
              webtext: `${d}`
            }))

            const variations = [
              {
                itemNumber: p.ProductToken,
                itemColorName: 'Standard',
                itemColorCode: '',
                pictures,
                skus
              }
            ]

            return {
              productName: p.BrandName,
              productBrand: p.BrandName,
              productNumber: p.ProductToken,
              price: null,
              productText: p.BrandDescription || '',
              picture: { url: p.LogoFile || null },
              discountPct: p.Discount,
              variations
            }
          })

        this.setState({ status: STATUS.UPDATE_SUCCESS })
        nextState.products = mapped
        nextState.pageInfo = {
          page: payload && payload.page ? payload.page : 1,
          pageSize: payload && payload.pageSize ? payload.pageSize : mapped.length
        }
        nextState.totalCount = mapped.length
      }
      this.setState(nextState)
    })
  }

  getSuppliersWithProductSync() {
    GET('suppliers/product-sync').then(responseJSON => {
      let nextState = { suppliers: [] }
      if (responseJSON.error) {
        nextState.status = STATUS.FETCHING_ELEMENTS_ERROR
      } else {
        this.setState({ status: STATUS.UPDATE_SUCCESS })
        nextState.suppliers = responseJSON
      }
      this.setState(nextState)
    })
  }

  exportSelection(payload) {
    POST('/products/export-nwg-products', payload).then(responseJSON => {
      let nextState = {}
      if (responseJSON.error) {
        nextState.status = STATUS.FETCHING_ELEMENTS_ERROR
      } else {
        if (responseJSON.ProductID) {
          window.open(`/products/${responseJSON.ProductID}`, '_blank')
        } else {
          this.setState({ status: STATUS.UPDATE_SUCCESS })
        }
      }
      this.setState(nextState)
    })
  }
}
